module.exports = __webpack_public_path__ + "static/media/pic_7_28.8b4f948f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/pic_7_28.jpg
// module id = 1840
// module chunks = 0 1